module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-foreword element-with-heading",
    attrs: {
      "id": "foreword"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "foreword-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Foreword")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "foreword-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("The author takes no responsibility for the validity of factual research conducted during the writing of this book. Please note that there is no insinuation that the British government and its officers nor the PGA European Golf Tour, its employees, players, caddies, sponsors or agents are in any way or have ever been corrupt. There is no deliberate intention to relate Russian criminality to the oil and gas industry, to sport or to politics except for solely creative purposes. References to real companies such British Petroleum are only used to add corporate authenticity within the book around the subject matter and there is no insinuation that they are or ever have been involved in any political or commercial corruption. Rublex Corporation is an entirely fictional entity with no reference to any existing or previous organisation.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2eaf5090","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/foreword.vue
// module id = 72
// module chunks = 0